const makeUuid = (seed: number = 100) =>
    Math.random()
        .toString(36)
        .substring(2, 2 + seed);

export { makeUuid };
